import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('PRESENTATIONS', ['MODAL_FORM', 'LIST_FORM'])
